import {React, useState} from "react";
import { nanoid } from "nanoid";
import { useSelector } from "react-redux";

import { Card } from "@lightspeed/flame/Card";
import arrow from "../../../assets/arrow.png";

import SideListItem from "./sideList/SideListItem";

const SideList = ({
  label,
  list,
  listN,
  openList,
  setOpenList,
  setDashMain,
}) => {
  const ui = useSelector((state) => state.ui);
  const database = useSelector((state) => state.database);
  //const [activeItem, setActiveItem] = useState(null); // added 23.9.2024

  return (
    <div className="side-list-wrapper">
      <div
        onClick={(_) => {
          if (openList.current === listN) {
            setOpenList({ current: 0 });
          } else {
            setOpenList({ current: listN });
          }
        }}
        className={`side-label ${listN === openList.current ? "rotate" : ""}`}
      >
        <p>{label}</p>
        <img src={arrow} alt="arrow" />
      </div>
      <Card
        className={`side-list-card ${ui.theme === "flame" ? "" : "dark2"} ${
          openList.current === listN ? "expand-side-list" : ""
        }`}
      >
        {list.length === 0 && (
          <SideListItem
            item={{ company_id: 1, company_name: "no items" }}
            setDashMain={setDashMain}
            //onClick={() => setActiveItem(1)} // added 23.9.2024
          />
        )}

        {list.map((item) => (
          <SideListItem
            current={database.currentCompany.id}
            key={nanoid()}
            item={item}
            listN={listN}
            setDashMain={setDashMain}
            //active={activeItem === item.company_id} // added 23.9.2024
            //onClick={() => setActiveItem(item.company_id)} // added 23.9.2024
          />
        ))}
      </Card>
    </div>
  );
};

export default SideList;
